import { StepIds, stepIds } from './stepIds';

export const isPostJobStep = (stepId: string): stepId is StepIds => {
  const stepIdsInArray = Object.values(stepIds);
  return stepIdsInArray.includes(stepId as StepIds);
};
